
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { RiRefreshLine } from "react-icons/ri";
import { IoSearchOutline } from "react-icons/io5";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import LeaseApiService from '../../services/apiService';
import WindowedSelect from 'react-windowed-select';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { ClipLoader } from "react-spinners";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment/moment';
import Modal from 'react-bootstrap/Modal';


const LeaseRevenueList = () => {
    const [FilterTab, setFilterTab] = useState(true);
    const [Tab, setTab] = useState(true);
    const [unitList, setUnitList] = useState([])
    const [proprtyList, setProperty] = useState([]);
    const [DebitList, setDebitList] = useState([]);
    const [CreditList, setCreditList] = useState([]);
    const [dataList, setDataList] = useState([]);
    const apiService = new LeaseApiService();
    const [loading, setloader] = useState(false);
    const [saveLoader, setloading] = useState(false);
    const [periodFrom, setPeriodFrom] = useState("");
    const [contcextMenu, setContextMenu] = useState();
    const [periodTo, setPeriodTo] = useState("");
    const [postedDate, setpostedDate] = useState("");
    const [isCleared, setIscleared] = useState(false);
    const [unposted, setunposted] = useState(false);
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    const [selectedRows, setSelectedRows] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [activeFY, setActiveFY] = useState(null);
    const [GlModal, setGlModal] = useState(false);
    const [pendingBody, setPendingBody] = useState(null);

    const onGridReady = (params) => {
        setGridApi(params.api);
    };
    useEffect(() => {
        fetchDropdownData();
    }, []);

    useEffect(() => {
        const today = new Date();

        // Clone today's date and subtract one month
        const lastMonth = new Date(today);
        lastMonth.setMonth(today.getMonth() - 1);

        const formattedToday = today.toISOString().split("T")[0];
        const formattedLastMonth = lastMonth.toISOString().split("T")[0];

        setPeriodFrom(formattedLastMonth);
        setPeriodTo(formattedToday);
        setpostedDate(formattedToday);

        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);

        return () => window.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        if (gridApi) {
            gridApi.forEachNode((node) => {
                node.setSelected(selectedRows.some(r => r.leaseNo === node.data.leaseNo));
            });
        }
    }, [dataList]);

    useEffect(() => {
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
        }
    }, []);

    const [transData, setTransData] = useState({
        debitAcc: [{ label: 'Select Debit Account', value: '' }],
        property: [{ label: 'Select Property', value: '' }],
        CraditAcc: [{ label: 'Select Credit Account', value: '' }],
        uniNo: [{ label: 'Select Unit No', value: '' }],
        Narration: ""
    });
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRPSerPropertyName,LRPDebitAccount,LRPCreditAccount');
            const res = await apiService.getApiParamater('GET_REVENUE_MULTI', `?${params.toString()}`);
            setProperty(res?.data?.dropdowns?.LRPSerPropertyName)
            setDebitList(res?.data?.dropdowns?.LRPDebitAccount)
            setCreditList(res?.data?.dropdowns?.LRPCreditAccount)
            const cust1params = new URLSearchParams();
            cust1params.append('Action', 'GetDebitAccountForPosting');
            const cust1res = await apiService.getApiParamater('GET_REVENUE_COMMON', `?${cust1params.toString()}`);
            const editedRow = res?.data?.dropdowns?.LRPDebitAccount?.find(row => row.value === cust1res.data.result.data.Debit);
            setTransData({
                ...transData,
                debitAcc: { label: editedRow?.text || "", value: editedRow?.value || "" },
            });

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handlePropertyChange = async (selectedOption) => {
        const params = new URLSearchParams();
        params.append('DropdownFor', 'LRPUnitNosByProperty');
        params.append('CascadValue', selectedOption?.value);
        const res = await apiService.getApiParamater('GET_REVENUE_CASCAD', `?${params.toString()}`);
        setUnitList(res?.data?.items);
        setTransData({
            ...transData,
            property: selectedOption,
            uniNo: [{ label: '', value: '' }]
        });
    }
    const handleUitNo = (selectedOption) => {
        setTransData({ ...transData, uniNo: selectedOption });
    }
    const handleDebit = (selectedOption) => {
        setTransData({ ...transData, debitAcc: selectedOption });
    }
    const handleCredit = (selectedOption) => {
        setTransData({ ...transData, CraditAcc: selectedOption });
    }
    const handleClearFilters = () => {
        setTransData({
            debitAcc: [{ label: 'Select Debit Account', value: '' }],
            property: [{ label: 'Select Property', value: '' }],
            CraditAcc: [{ label: 'Select Credit Account', value: '' }],
            uniNo: [{ label: 'Select Unit No', value: '' }],
        });
        setUnitList([])
        setSelectedRows([])
        setDataList([])
    }
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handlePeriodFromChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodFrom(formattedDate);
    }
    const handlePeriodToChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodTo(formattedDate);
    }
    const handlePostingDate = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setpostedDate(formattedDate);
    }
    const handleCleared = () => {
        setIscleared(!isCleared);
    };
    const handleUnposted = () => {
        setunposted(!unposted);
    };
    const SearchItems = async () => {
        try {
            setloader(true);
            const params = new URLSearchParams();
            params.append('PropertyNo', transData?.property?.value || 'All');
            params.append('UnitNo', transData?.uniNo?.label || 'All');
            params.append('FromDate', periodFrom);
            params.append('ToDate', periodTo);
            params.append('PMUnits', isCleared);
            params.append('UnPosted', unposted);
            const res = await apiService.getApiParamater('GET_REVENUE_LIST', `?${params.toString()}`);
            setDataList(res?.data?.result || []);
            setloader(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setloader(false);
        }
    }
    const handlefieldChange = (e) => {
        setTransData({ ...transData, [e.target.name]: e.target.value });
    };
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const columnDefs = [
        {
            checkboxSelection: true,
            headerCheckboxSelection: true,
            field: 'isSelected',
            width: 50,
            pinned: 'left'
        },
        { headerName: 'Lease No', field: 'leaseNo', filter: true, width: 200, suppressMovable: false, pinned: 'left' },
        { headerName: 'Property Name', field: 'propertyName', filter: true, suppressMovable: false, width: 280 },
        { headerName: 'Unit No', field: 'unitNo', filter: true, suppressMovable: false, width: 150 },
        { headerName: 'Credit Account', field: 'crAcCode', filter: true, suppressMovable: false, width: 150 },
        { headerName: 'Debit Account', field: 'drAcCode', filter: true, suppressMovable: false, width: 150 },
        { headerName: 'Posted Amount', field: 'postedAmount', filter: true, suppressMovable: false, width: 150 },
        { headerName: 'Balance', field: 'balance', filter: true, suppressMovable: false, width: 150 },
        { headerName: 'Narration', field: 'narration', filter: true, suppressMovable: false, width: 250 },
        {
            headerName: 'Lease From', field: 'leaseDate',
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: false, width: 130,
        },
        {
            headerName: 'Lease To', field: 'leaseExpiry',
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: false, width: 130,
        },
        { headerName: 'Total Lease', field: 'totalLeaseDays', suppressMovable: false, width: 250 },
        { headerName: 'Contract Value', field: 'contractValue', suppressMovable: false, width: 250 },
        { headerName: 'Rent Per Day', field: 'rentPerDay', filter: true, suppressMovable: false, width: 250 },
        { headerName: 'Days to Calculate', field: 'daysToCalculate', filter: true, suppressMovable: false, width: 250 },
        { headerName: 'Posting Amount', field: 'postingAmount', filter: true, suppressMovable: false, width: 250 },
    ]
    const onCloseModal = () => {
        setGlModal(false);
        setPendingBody(null);
    };
    const handlePostAnyway = async () => {
        setGlModal(false);
        if (pendingBody) {
            await postRevenue(pendingBody);
            setPendingBody(null);
        }
    };
    const handleSave = async () => {
        try {
            setloading(true);
            if (selectedRows.length === 0) {
                toast.warning(`Please Select Lease from the Posting Grid`);
                setloading(false);
                return;
            }
            // for (const item of selectedRows) {
            //     if (item?.crAcCode === "0" || "" || item?.crAcName === "0" || "") {
            //         toast.warning(`Please add credit acc to ${item?.propertyName}`)
            //         setloading(false);
            //         return
            //     } else if (item?.drAcCode === "0" || "" || item?.drAcName === "0" || "") {
            //         toast.warning(`Please add debit acc to ${item?.leaseNo}`)
            //         setloading(false);
            //         return
            //     }
            // }

            const hasInvalidCredit = selectedRows.some(
                item => item?.crAcCode === "0"
            );


            const _LeaseRevenuGrid = selectedRows?.map(item => {
                return {
                    isSelected: true,
                    leaseNo: item?.leaseNo,
                    propertyNo: item?.propertyNo,
                    propertyName: item?.propertyName,
                    unitNo: item?.unitNo,
                    unitRefNo: item?.unitRefNo,
                    narration: item?.narration,
                    leaseDate: item?.leaseDate,
                    leaseExpiry: item?.leaseExpiry,
                    totalLeaseDays: item?.totalLeaseDays,
                    contractValue: item?.contractValue,
                    vat: item?.vat,
                    rent: item?.rent,
                    balance: item?.balance,
                    rentPerDay: item?.rentPerDay,
                    daysToCalculate: item?.daysToCalculate,
                    postingAmount: item?.postingAmount,
                    recordId: item?.recordId,
                    postedAmount: item?.postedAmount,
                    crAcCode: item?.crAcCode,
                    // crAcCode: item?.crAcCode === "0" ? transData?.CraditAcc?.value : item?.crAcCode,
                    crAcName: item?.crAcName,
                    // crAcName: item?.crAcName === "0" ? transData?.CraditAcc?.label : item?.crAcName,
                    drAcCode: item?.drAcCode,
                    // drAcCode: item?.drAcCode === "0" ? transData?.debitAcc?.value : item?.drAcCode,
                    drAcName: item?.drAcName,
                    // drAcName: item?.drAcName === "0" ? transData?.debitAcc?.label : item?.drAcName,
                    fYear: activeFY?.value?.id,
                    isPosted: item?.isPosted
                }
            });

            const body = {
                leaseRevenueMain: {
                    propertyNo: transData?.property?.value || "",
                    unitNo: transData?.uniNo.label || "",
                    periodFrom: periodFrom,
                    periodTo: periodTo,
                    pmUnits: isCleared,
                    unPostedUnits: unposted,
                    postingDate: postedDate,
                    debitAccount: transData?.debitAcc?.value,
                    creditAccount: transData?.CraditAcc?.value,
                    refNo: "0",
                    narration: transData.Narration || "",
                    _LeaseRevenuGrid: _LeaseRevenuGrid,
                },
            };
            // 👉 C# equivalent condition
            if (hasInvalidCredit) {
                setPendingBody(body);   // store request
                setGlModal(true);       // show popup
                setloading(false);
                return;
            }

            // Normal post
            await postRevenue(body);


        } catch (error) {
            setloading(false);

            console.error("Error Save Data", error);
        }
    }
    const postRevenue = async (body) => {
        try {
            setloading(true);
            const postRes = await apiService.post("POST_REVENUE", body);
            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
                toast.success(`Posted  successfully`);
                // window.location.reload()
                setloading(false);
            } else {
                setloading(false);
            }
        } catch (error) {
            console.error("Post Error", error);
        } finally {
            setloading(false);
        }
    };

    return (
        <div className='p-3'>
            <div className="cost-center-section mb-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>Search Details</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '10px' }}>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Property</label>
                                <WindowedSelect
                                    className="w-75 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    value={transData.property}
                                    options={proprtyList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                />
                            </div>
                            <div className='d-flex'>
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> From Date</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={periodFrom}
                                    onChange={(date) => handlePeriodFromChange({ name: 'leaseDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex gap-4 center">
                                <input
                                    style={{ width: "20px", height: "20px" }}
                                    type="checkbox"
                                    className="form-check-input center"
                                    checked={isCleared}
                                    onChange={handleCleared}
                                />
                                <label htmlFor="validationCustom01" className="form-label pt-2 start"> Include PM Units</label>
                            </div>
                            <div className="center d-flex gap-3">
                                {loading === true ? (
                                    <div className="mainbtnGry w-50">
                                        <ClipLoader color="#ffffff" className="mt-1" size={25} />
                                    </div>
                                ) : (
                                    <div className="mainbtnGry flex-end gap-2" onClick={SearchItems}>
                                        <IoSearchOutline color="#fff" className="center mt-1 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                )}
                                <div className="mainbtnRed flex-end gap-2" onClick={handleClearFilters} >
                                    <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> Unit No</label>
                                <WindowedSelect
                                    className="w-75 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    value={transData.uniNo}
                                    options={unitList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handleUitNo(selectedOption)}
                                />
                            </div>
                            <div className='d-flex'>
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> To Date</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={periodTo}
                                    onChange={(date) => handlePeriodToChange({ name: 'toDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex gap-4 center">
                                <input
                                    style={{ width: "20px", height: "20px" }}
                                    type="checkbox"
                                    className="form-check-input center"
                                    checked={unposted}
                                    onChange={handleUnposted}
                                />
                                <label htmlFor="validationCustom01" className="form-label pt-2 start">Show Unposted only</label>
                            </div>
                            <div className='center'>
                                {saveLoader === true ? (
                                    <div className="mainbtn flex-end gap-2 w-50">
                                        <ClipLoader color="#ffffff" className="mt-1" size={25} />
                                    </div>
                                ) : (
                                    <div className="mainbtn flex-end gap-2 w-50" onClick={handleSave}>
                                        <FaSave color="#fff" className="center mt-1 mx-2" />
                                        <div className="center">Save</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setTab(!Tab)}>
                    <div className='h6 pt-1'>Transection Details</div>
                </div>
                <div className={`slide-content ${Tab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${Tab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '10px' }}>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Debit Account</label>
                                <WindowedSelect
                                    className="w-75 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    isDisabled
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    value={transData.debitAcc}
                                    options={DebitList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handleDebit(selectedOption)}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Credit Account</label>
                                <WindowedSelect
                                    className="w-75 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    isDisabled
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    value={transData.CraditAcc}
                                    options={CreditList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handleCredit(selectedOption)}
                                />
                            </div>
                            <div className='d-flex'>
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> Posting Date</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={postedDate}
                                    onChange={(date) => handlePostingDate({ name: 'postedDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-1 start">Narration</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="Narration"
                                    value={transData?.Narration}
                                    onChange={handlefieldChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='gridshad mt-1'>
                <div className='table-container'>
                    <div className="ag-theme-quartz" style={{ height: 650 }}>
                        <AgGridReact
                            getRowStyle={(params) => {
                                return { background: params.node.rowIndex % 2 === 0 ? '#F0EDF5' : '#fff' };
                            }}
                            rowData={dataList}
                            columnDefs={columnDefs}
                            suppressRowClickSelection={true}
                            rowSelection="multiple"
                            rowMultiSelectWithClick={true}
                            // getRowId={(params) => params.data.leaseNo}
                            onGridReady={onGridReady}
                            onSelectionChanged={(params) => {
                                const selected = params.api.getSelectedRows();
                                setSelectedRows(selected);
                            }}
                        />
                    </div>
                </div>
            </div>
            <Modal size="sm"
                show={GlModal}
                onHide={onCloseModal}
                contentLabel="Email Modal"
                style={customStyles}
                closeButton
            >
                <Modal.Header closeButton>
                    <Modal.Title className="center">
                        Invalid Account Code
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        Invalid credit accounts found. Those units revenue will not post.
                    </div>
                </Modal.Body>

                <Modal.Footer className="end p-3">
                    <button className="mainbtn" onClick={onCloseModal}>
                        Cancel
                    </button>
                    <button className="mainbtn" onClick={handlePostAnyway}>
                        Post
                    </button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default LeaseRevenueList;
const customStyles = {
    content: {
        width: '30%', // Set the desired width
        height: '75%', // Set the desired 
        top: '50%', // Center vertically
        left: '50%', // Center horizontally
        right: '50%', // Center horizontally
        transform: 'translate(-50%, -50%)', // Center both vertically and horizontally
    },
};
